// Decides which sidebar entries to render, given the current user's
// permissions and any active search query.
//
// Two rules beyond "does this exact route pass hasPermission/match the
// search":
//  - A "title" or "divider" section header only renders if at least one
//    collapse route inside that section is actually visible to this user.
//    Without this, a user with zero granted pages in, say, "Payments"
//    would still see an empty "Payments" header with nothing under it.
//  - A section is everything between one divider and the next divider —
//    a title, if the section has one, sits inside that same section
//    rather than starting a new one (routes.js has some divider-only
//    sections, e.g. "Account", with no title entry at all).
export function getVisibleRoutes(routes, hasPermission, searchQuery) {
  const isPermittedCollapse = (route) =>
    route.type === "collapse" && !!route.key && hasPermission(route.key);

  const visibleCollapseKeys = new Set(routes.filter(isPermittedCollapse).map((route) => route.key));

  const sectionHasVisibleRoute = (startIndex) => {
    for (let i = startIndex; i < routes.length; i++) {
      const route = routes[i];
      if (route.type === "divider") return false; // next section starts here
      if (route.type === "collapse" && route.key && visibleCollapseKeys.has(route.key)) {
        return true;
      }
      // type === "title" or "route" (e.g. a detail sub-page not shown in the
      // sidebar) — still within this section, keep scanning.
    }
    return false;
  };

  return routes.filter((route, index) => {
    if (route.type === "collapse" && route.key) {
      if (!visibleCollapseKeys.has(route.key)) return false;
    }

    if (route.type === "divider" || route.type === "title") {
      if (!sectionHasVisibleRoute(index + 1)) return false;
    }

    if (!searchQuery) return true;
    if (route.type === "collapse" && route.name) {
      return route.name.toLowerCase().includes(searchQuery.toLowerCase());
    }
    return true;
  });
}
